/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: OpenVip 组件（用于 photov2，避免跨目录依赖）
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-11-25
 */
import React from 'react'
import { useDispatch } from 'react-redux'
import lock from '../../../images/photo_lock.png'
import { setPaymentVisible } from '../../../actions/main'

interface OpenVipProps {
  topMargin?: number
  onSensorOfClickEvent?: (clickItem: string, restProperties?: any) => void
}

const OpenVip: React.FC<OpenVipProps> = ({
  topMargin = 0,
  onSensorOfClickEvent
}) => {
  const dispatch = useDispatch()

  const handleOpenVip = () => {
    // 触发埋点
    if (onSensorOfClickEvent) {
      onSensorOfClickEvent('openVipNow')
    }
    dispatch(setPaymentVisible(true, 'webAllPhotoObscure'))
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        zIndex: 11,
        width: 'auto',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        marginTop: topMargin
      }}
    >
      <div className="lock-icon" style={{ marginBottom: '20px' }}>
        <img src={lock} alt="lock" style={{ width: '19px', height: '23px' }} />
      </div>
      <div
        className="lock-text"
        style={{ fontSize: '18px', color: '#9A6516', marginBottom: '20px' }}
      >
        开通团队会员即可查看90天前的照片
      </div>
      <button
        className="open-vip-button"
        onClick={handleOpenVip}
        style={{
          width: '125px',
          height: '38px',
          background: 'linear-gradient(to right, #FE992A, #FB425D)',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          fontSize: '17px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        立即开通
      </button>
    </div>
  )
}

export default OpenVip
